import React, {useState, useContext, useEffect} from "react";
import moment from 'moment'
import InfoSection from "./info-section";
import { courseCategoryOptions,translateOptionValue, courseStatusOptions} from '../../../../components/exl/shared/translations';
import FilterCell from "../../../../components/exl/TeacherCoursesFilterCell";
import OnHoverTooltip from "../../../../components/tables/shared/OnHoverTooltip";
import { useTranslation } from 'react-i18next';
import { TEACHER_COURSES_COURSES_LABEL, TEACHER_COURSES_COURSE_CATEGORY_LABEL, TEACHER_COURSES_COURSE_END_LABEL, TEACHER_COURSES_COURSE_START_LABEL, TEACHER_COURSES_COURSE_STATUS_LABEL, TEACHER_COURSES_FILTER_TOOLTIP, TEACHER_COURSES_NO_COURSES, TEACHER_COURSES_NO_SET_DATE } from "../../../../i18n/keyConstants";


export default function TeacherCoursesComponent ({ teacherUser, teacherCourses}) {

    const [coursesToDisplay, setCoursesToDisplay] = useState([]);
    const { t } = useTranslation(['teacherCourses', 'shared']);

    // Remove courses with status None if user does not have edit permission
    function initialCourseFilter(courses) {
        var relevantCourses;
        if (!teacherUser.editPermission && !teacherUser.compensationTypePermission) {
            relevantCourses = courses.filter(course => course.status !== courseStatusOptions.None.value)
        }
        else {
            relevantCourses = courses;
        }
        return relevantCourses;
    }

    useEffect(() => {
        setCoursesToDisplay(initialCourseFilter(teacherCourses));
    }, [teacherCourses]);

    // Remove courses with status None if user does not have edit permission
    function initialCourseFilter(courses) {
        var relevantCourses;
        if (!teacherUser.editPermission && !teacherUser.compensationTypePermission) {
            relevantCourses = courses.filter(course => course.status !== courseStatusOptions.None.value)
        }
        else {
            relevantCourses = courses;
        }
        return relevantCourses;
    }

    if(coursesToDisplay.length === 0){
        return (
            <>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="d-flex align-items-start ">
                    <FilterCell className={"th-noborder"} column={{ name: "status" }}></FilterCell>
                    <OnHoverTooltip
                        labelClassNames="d-flex margin-none"
                        tooltipType="dark"
                        tooltipPlace="top"
                        tooltipEffect="solid"
                    >
                        <span
                            className="oi oi-info c-steelblue padding-left-20px"
                            style={{ fontSize: "10px", paddingTop: "12px" }}
                        />
                            {t(TEACHER_COURSES_FILTER_TOOLTIP)}
                    </OnHoverTooltip>
                </div>
                    <div style={{ color: "grey", paddingTop: "10px" }}>{t(TEACHER_COURSES_NO_COURSES)}
</div>
            </div>
        </>
        )
    }

    return (
        <div>
            <div className="d-flex align-items-start" style={{borderBottom: "none"}}>
                <FilterCell column={{ name: "status" }} ></FilterCell>
                <OnHoverTooltip
                    labelClassNames='d-flex margin-none'
                    tooltipType='dark'
                    tooltipPlace='top'
                    tooltipEffect='solid'>
                    <span className='oi oi-info c-steelblue padding-left-20px' style={{ fontSize: "10px", paddingTop: "12px" }} />
                    {t(TEACHER_COURSES_FILTER_TOOLTIP)}
                </OnHoverTooltip>
            </div>
            {coursesToDisplay.map((course) => (
                <div className={"d-flex card ml-auto p-2 mb-2 list-card"} key={course.id}>
                    <a href={`/exlCourseDetails/${course.id}`}>
                        <h4 style={{marginBottom: "1.0rem", paddingTop: "0px"}}> {course.name}</h4>
                    </a>

                    <div className='d-flex flex-wrap'>
                        <InfoSection paddingTop="0px" marginBottom="0px" sectionLabel={t(TEACHER_COURSES_COURSE_START_LABEL)}>
                            {course.startDate !== null ? moment.utc(course.startDate).local().format('YYYY-MM-DD') : t(TEACHER_COURSES_NO_SET_DATE)}
                        </InfoSection>

                        <InfoSection paddingTop="0px" marginBottom="0px" sectionLabel={t(TEACHER_COURSES_COURSE_END_LABEL)}>
                            {course.endDate !== null ? moment.utc(course.endDate).local().format('YYYY-MM-DD') : t(TEACHER_COURSES_NO_SET_DATE)}
                        </InfoSection>

                        <InfoSection marginBottom="0px" sectionLabel={t(TEACHER_COURSES_COURSE_STATUS_LABEL)}>
                            {t(translateOptionValue(course.status, courseStatusOptions), { ns: 'shared' })}
                        </InfoSection>

                        <InfoSection marginBottom="0px" sectionLabel={t(TEACHER_COURSES_COURSE_CATEGORY_LABEL)}>
                            {t(translateOptionValue(course.category, courseCategoryOptions), { ns: 'shared' })}
                        </InfoSection>
                    </div>

                </div>
            ))}                        
        </div>
    )
}